export default {
    init() {
        $('.product-slider-inside').lightSlider({
            item: 3,
            slideMove: 1,
            loop:false,
            easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
            speed:600,
            controls: true,
            pager: false,
            adaptiveHeight:true,
            slideMargin: 10,
            responsive : [
                {
                    breakpoint:1100,
                    settings: {
                        item:2,
                        slideMove:1,
                    },
                },
            ],
        });
    },
    finalize() {


    },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js